import { useMutation } from '@apollo/client';
import registerViaFacebookMutation from './RegisterViaFacebookMutation';

const RegisterViaFacebookConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(registerViaFacebookMutation);

  const createRegisterViaFacebook = async (token) => {
    const response = await mutate({
      variables: {
        token,
      },
    });

    return response;
  };

  return children({
    registerViaFacebook: createRegisterViaFacebook,
    loading,
  });
};

export default RegisterViaFacebookConnectorApollo;
